// extracted by mini-css-extract-plugin
var _1 = "CarouselDropzone-module__container--pju1V";
var _2 = "CarouselDropzone-module__dropzoneIcon--Kl09y";
var _3 = "CarouselDropzone-module__label--Uw0jc";
export { _1 as "container", _2 as "dropzoneIcon", _3 as "label" }
